import Vue from 'vue';

export default {
 
  async fetchQhsesByDprId({ commit }, dprId) {
    return Vue.axios.get(Vue.$url("vessel-qhse?dprId=" + dprId))
      .then((rsp) => commit("SET_QHSES", rsp.data))
  },

}